import React, { useState, useEffect } from 'react';
import { Breadcrumb } from 'antd';
import { HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import ActivitySwitch from 'modules/layoutModule/components/ActivitySwitch/ActivitySwitch';
import {
  Form,
  Input,
  Button,
  Space,
  Skeleton,
  ConfigProvider,
  BackTop,
} from 'antd';
import { FieldData } from 'rc-field-form/lib/interface';
import { useHistory } from 'react-router-dom';
import plPL from 'antd/lib/locale/pl_PL';
import {
  getSpecificGtwFileRequest,
  saveGtwFile,
} from '../requests/gtwRequests';
import FormFileUpload from 'modules/galleryModules/components/FormFileUpload';

import 'moment/locale/pl';

const GtwFilesEdit = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const [fields, setFields] = useState<FieldData[]>([]);
  const [loading, toggleLoading] = useState<boolean>(false);
  const history = useHistory();
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [isActivityDisabled, toggleActivityDisable] = useState(false);
  const [file1, setFile1] = useState<string | null>(null);
  const [file1Changed, changedFile1] = useState<boolean>(false);

  useEffect(() => {
    toggleLoading(true);
    getSpecificGtwFileRequest(id)
      .then((response) => {
        if (response) {
          toggleLoading(false);
          const { data } = response;
          setFields([
            {
              name: ['id'],
              value: data.id,
            },
            {
              name: ['title'],
              value: data.title,
            },
            {
              name: ['isActive'],
              value: data.isActive || false,
            },
            {
              name: ['uploadedFile1'],
              value: data.uploadedFile1,
            },
          ]);
          setFile1(data?.fileName1);

          form.setFieldsValue({
            uploadedFile1: data?.uploadedFile1,
          });
        } else {
          history.push('/gtw-files');
        }
      })
      .catch(() => {
        history.push('/gtw-files');
      });
  }, []);

  const onFinish = (values: any) => {
    toggleButtonLoading(true);
    saveGtwFile(values).then(() => {
      toggleButtonLoading(false);
    });
  };

  const updateFile = (
    e: string,
    field: string,
    coverMethod: (value: string) => void,
    coverMethodChanged: (value: boolean) => void
  ) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
    coverMethod(e);
    coverMethodChanged(true);
  };

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Grunt to Wiedza</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/gtw-files">Edycje pliki</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/gtw-files/${id}`}>Edycja wpisu</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <ConfigProvider locale={plPL}>
        <div className="site-layout-background">
          {loading && <Skeleton active />}
          {!loading && (
            <Form
              layout="vertical"
              fields={fields}
              onFinish={onFinish}
              form={form}
              validateMessages={validateMessages}
            >
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>
              <Form.Item
                name="title"
                label="Nazwa pliku"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item name="fileName1" label="Plik do pobrania PDF">
                <FormFileUpload
                  file={file1}
                  setFile={(e) =>
                    updateFile(e, 'fileName1', setFile1, changedFile1)
                  }
                  isNew={file1Changed}
                  field="fileName1"
                />
              </Form.Item>

              <ActivitySwitch isActivityDisabled={isActivityDisabled} />
              <Form.Item>
                <Space>
                  <Button
                    type="primary"
                    htmlType="submit"
                    icon={<SaveOutlined />}
                    loading={isSaveButtonLoading}
                  >
                    Zapisz
                  </Button>
                  <Link to="/gtw-files">
                    <Button>Powrót</Button>
                  </Link>
                </Space>
              </Form.Item>
            </Form>
          )}
          {loading && (
            <Link to="/gtw-files">
              <Button>Powrót</Button>
            </Link>
          )}
          <BackTop />
        </div>
      </ConfigProvider>
    </>
  );
};

export default GtwFilesEdit;
